/// <amd-module name="typeahead/core/DynamicDropdownSuggestion"/>

import {ListItemType} from "typeahead/core/IListItem";
import {Suggestion} from "typeahead/core/Suggestion";

// Models the suggestions in dynamicDropdown, a feature in storefront-web used for on-focus suggestions on the Japanese
// version of www.expedia.co.jp. Refer to:
// https://ewegithub.sb.karmalab.net/EWE/storefront-web/blob/master/src/main/webapp/static/module/dynamicDropdown/
//     dynamicDropdown.js
export class DynamicDropdownSuggestion extends Suggestion {
    constructor(private displayText: string) {
        super({
            category: "DynamicDropdownSuggestion",
            coordinates: undefined,
            index: "0",
            listItemType: ListItemType.Suggestion,
            regionNames: undefined,
            type: "DynamicDropdownSuggestion",
        });
    }

    public getDisplayText(): string {
        return this.displayText;
    }

    public shouldTriggerDomElementChangeOnSelection(): boolean {
        return true;
    }
}
